import React from 'react';
import { SelectTitle } from './styles';
import './input-field.scss';
import { RenderComponent } from './render.comp';

export const MultipleInputField = (props) => {
  const {
    isLoading = false,
    style = {},
    wrapperStyle = {},
    inputStyle = {},
    selectStyles = {},
    firstComponentInputStyle = {},
    name,
    key,
    width = 272,
    firstComponent = {
      rightIcon: null,
      isAsyncPagination: false,
      defaultValue: '',
      onChange: null,
      placeholder: '',
      onSearch: null,
      options: [],
      disabled: false,
      componentKey: '',
      max: null,
      min: null,
    },
    secondComponent = {
      rightIcon: null,
      isAsyncPagination: false,
      defaultValue: '',
      onChange: null,
      placeholder: '',
      onSearch: null,
      options: [],
      disabled: false,
      max: null,
      min: null,
    },
  } = props;


  return (
    <div style={{ minWidth: width, width: '100%' }}>
      {name && <SelectTitle>{name}</SelectTitle>}
      <div style={{ display: 'flex', alignItems: 'end', gap: '8px', ...wrapperStyle }}>
        {firstComponent && (
          <RenderComponent
            isLoading={isLoading}
            style={style}
            inputStyle={{...inputStyle, ...firstComponentInputStyle}}
            selectStyles = {selectStyles}
            width={width}
            {...firstComponent}
          />
        )}
        {secondComponent && (
          <RenderComponent
            isLoading={isLoading}
            style={style}
            inputStyle={inputStyle}
            selectStyles = {selectStyles}
            width={width}
            {...secondComponent}
            isSecondComp={true}
          />
        )}
      </div>
    </div>
  );
};

